import React, {  useState, useEffect  } from 'react'; 
import { get_cdn_doc } from '../../../../services/projectservice.js'
import { TTDoc } from '../../editor/tiptap/TipTapViewer.jsx'; 
import { tiptap_doc_id } from './demo_util.js'

export default function CDNDocDemo({}) {
  
    const [tiptapData, setTiptapData] = React.useState(null);
    const [loadError, setLoadError] = React.useState('');
        
    const handleLoad = (data) => {
        setTiptapData(data.data);
    }

    const handleLoadError = (error) => {
        console.error("Error loading data:", error);
        setLoadError(`Error loading data: ${error}`);
    }

    useEffect(() => { 
        get_cdn_doc(tiptap_doc_id, handleLoad, handleLoadError) 
    }, []);
    
    return (<> 
        <h2>CDN Doc Demo</h2>
        {tiptapData && <TTDoc ttData={tiptapData} />} 
    </>) 

}

